

<!-- <button (click)="reset($event)" class="btn btn-unika " style="left: 0; position: absolute; margin-top: 18rem">reset</button>
<button (click)="setColor('')" class="btn btn-unika" style="left: 0; position: absolute; margin-top: 8rem">set color</button> -->
<mat-progress-bar mode="determinate" value="{{ this.loaded }}"></mat-progress-bar>
<div class="loader" *ngIf="this.loaded < 100"> {{ this.loaded }} %</div>
<div *ngIf="this.isDescktop" class="col m12 iframe da-iframe threejs-main-spirikal" [innerHtml]="mainSpirikal | safe: 'html'"></div>
<!-- {{ this.loaded }}************** -->
<app-flat-propeties-onthe-fly [building]="this.currentBuilding" (isOnTheFly)="isOnTheFlyF($event)" (flatSelected)="onFlatSelected($event)"></app-flat-propeties-onthe-fly>
<div #canvas id="canvas" [class.isFlatPage]="this.inFlatProperties"></div>
<!-- document.getElementsByTagName('app-flat-propeties-onthe-fly')[0].addEventListener('click', function(event) {
    if (event.target === this) {
      event.stopPropagation(); 
      console.log('Клик на overlay-div, но не на детях.');
  }
}); -->
<!-- <div [innerHtml]="this.container | safe: 'html'"></div> -->
<!-- this.container -->

<!-- <app-gallery [galleryId]="'1'" [section]="this.projId + this.builUid + '3D'" [autoPlay]="true" [showThumbs]="false"
class="3d"></app-gallery> -->